import React from "react";
import { ArrowRight, Plane, Building2, Factory, Sparkles } from "lucide-react";
import { services } from "../mock";

const iconMap = { Plane, Building2, Factory, Sparkles };

export default function Services() {
  return (
    <section id="services" className="py-4">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative rounded-3xl overflow-hidden p-8 lg:p-10 min-h-[260px] flex flex-col justify-between transition-transform duration-300 hover:-translate-y-1"
                style={{ backgroundColor: service.bg }}
              >
                <div className="flex items-start justify-between gap-6">
                  <div className="max-w-xs">
                    <h3 className="font-serif text-3xl lg:text-4xl text-[#143527] mb-3">
                      {service.title}
                    </h3>
                    <p className="text-[14px] text-[#143527]/80 leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                  <div className="shrink-0 w-20 h-20 lg:w-24 lg:h-24 rounded-2xl bg-[#143527]/8 flex items-center justify-center">
                    {Icon && <Icon className="w-10 h-10 text-[#143527]" strokeWidth={1.4} />}
                  </div>
                </div>
                <a
                  href="#quote"
                  className="inline-flex items-center gap-2 mt-8 self-start rounded-full bg-[#143527] text-[#f4ebde] px-5 py-2.5 text-[13px] font-medium hover:bg-[#1f4d39] transition-colors"
                >
                  Book service
                  <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
